import { render, staticRenderFns } from "./ClickConfirm.vue?vue&type=template&id=075e8f20&"
import script from "./ClickConfirm.vue?vue&type=script&lang=js&"
export * from "./ClickConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports